document.documentElement.classList.remove('no-js');
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.toggleAttribute('data-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  const close = event.target.closest('[data-menu-close]');
  if (close) {
    document.querySelector('[data-mobile-menu]')?.removeAttribute('data-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  }
});
